import React from 'react'
import { useSelector } from 'react-redux'
import { PIX_MODAL_STAGES } from 'app-constants'
import { Copy, Error, QrCode } from './components'

function stages({ ...props }) {
  return {
    [PIX_MODAL_STAGES.INITIAL]: <QrCode {...props} />,
    [PIX_MODAL_STAGES.COPY]: <Copy {...props} />,
    [PIX_MODAL_STAGES.ERROR]: <Error {...props} />,
  }
}

export function PixModal() {
  const { stage, data } = useSelector(({ modal }) => modal)

  return stages({ data })[stage]
}
